import {View} from 'react-native'

import {Text} from '#/view/com/util/text/Text'
import {LoggedOutPage} from '#/view/shell/LoggedOutPage'
import {useTheme} from '#/alf'
import * as Layout from '#/components/Layout'

export function HeroSectionPage() {
  const t = useTheme()
  const isLight = t.name === 'light'

  return (
    <LoggedOutPage>
      <Layout.Center>
      <View style={{paddingLeft: 24}}>
        <div className="flex flex-col items-center justify-center py-16 gap-8 max-w-2xl w-full px-4">
          <div className="text-center w-full">
            <h1
              style={{
                fontSize: 32,
                color: isLight ? 'black' : 'white',
                fontWeight: '800',
                textAlign: 'left',
                lineHeight: 1.2,
                marginLeft: 15,
                marginBottom: 0,
              }}>
              <Text
                style={{
                  fontSize: 32,
                  color: isLight ? 'black' : 'white',
                  fontWeight: '800',
                }}>
                See what your bate bros
              </Text>
              <br />
              <Text
                style={{
                  fontSize: 32,
                  color: isLight ? 'black' : 'white',
                  fontWeight: '800',
                }}>
                are posting on Batesky
              </Text>
            </h1>
          </div>
        </div>
      </View>
      </Layout.Center>
    </LoggedOutPage>
  )
}
